import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';

interface ErrorStateCardProps {
  message: string;
  /** The next action offered beneath the message. Every feature page inherits the default (`common:errorState.refreshToTryAgain`). */
  action?: string;
}

export function ErrorStateCard({
  message,
  action,
}: ErrorStateCardProps) {
  const { t } = useTranslation('common');
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12">
        <AlertCircle className="h-12 w-12 text-destructive mb-4" />
        <p className="text-lg font-medium">{message}</p>
        <p className="text-body text-stevens-ink-3">{action ?? t('errorState.refreshToTryAgain')}</p>
      </CardContent>
    </Card>
  );
}
